export enum ClientPhotoPurpose {
  Avatar = 'avatar',
  Resume = 'resume',
}
